<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
  <path d="M10.3 4.2 L2.8 17.5 A2 2 0 0 0 4.5 20.5 H19.5 A2 2 0 0 0 21.2 17.5 L13.7 4.2 A2 2 0 0 0 10.3 4.2 Z"></path>
  <path d="M12 9.5 V13.5"></path>
  <circle cx="12" cy="16.8" r="0.4" fill="currentColor"></circle>
</svg>